import { MostrarMenu, SeleccionarEmpresa } from './../actions/utils.action';

import { createReducer, on } from '@ngrx/store';
import { MostrarExcepcion, MostrarSpinner, OcultarExcepcion, OcultarSpinner } from '../actions/utils.action';

export interface State {
    mostrarSpinner: boolean,
    mostrarExcepcion: boolean,
    pila: any,
    tipoExcepcion: number,
    mostrarMenu: boolean
}

export const initialState: State = {
    mostrarSpinner: false,
    mostrarExcepcion: false,
    pila: null,
    tipoExcepcion: 0,
    mostrarMenu: true,
};


const _utilsReducer = createReducer(
    initialState,
    on(MostrarSpinner, (state) => ({ ...state, mostrarSpinner: true })),
    on(OcultarSpinner, (state) => ({ ...state, mostrarSpinner: false })),
    on(MostrarExcepcion, (state, payload) => ({
        ...state,
        mostrarExcepcion: true,
        pila: payload.pila,
        tipoExcepcion: payload.tipoExcepcion
    })),
    on(OcultarExcepcion, (state) => ({
        ...state,
        mostrarExcepcion: false,
        pila: null,
        tipoExcepcion: 0
    })),
    on(MostrarMenu, (state, payload) => ({
        ...state,
        mostrarMenu: payload.mostrarMenu
    })),
    on(SeleccionarEmpresa, (state, payload) => ({
        ...state,
        empresaSeleccionada: payload.empresaSeleccionada
    }))
);

export function utilsReducer(state, action) {
    return _utilsReducer(state, action);
}

